/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 *  Observation Anlaytics Configuration
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { logNormal, logInformation, logWarning, logError, logDebug, logConsole, logRawTrack, logTransports, logAutomationError } from "./bootstrap_web_ext";
import {ModuleManager , globalEngine} from "./Init"

// #ENDIF WebPack
function getObservationAnalyticsEngine()
{
    /*!
     *  config format:
     *   'Message.Name' : {                 // name of obsved message on messagebus that we will subscribe to
     *       'map' : {                      // map from message keys --> analytic friendly keys
     *           'Count' : 'Metric1',       // ex. 'Count' : 123  --> 'Metric1' : 123
     *           'Policy' : 'Event.Label'   // ex. 'Policy' : 'XYZ' --> 'Event.Label' : 'XYZ'
     *       },
     *       'default' : {                  // default values that are not specified in the obsved message
     *           'Hit.UniqueID' : 'XYZ'
     *       }
     *   }
     */
    var config = 
    {
        'Testing.Mock': {
            'map': {
                'Success' : 'Received'
            },
            'default': {
                'Test.Value' : 'Yes'
            }
        },
        'WSSAlertPlugin.L3.AlertSuppressed': {
            'map': {
                'AlertID': 'Event.Label',
                'isSuppressedByL3Policy': 'Hit.Result'
            },
            'default': {
                'Hit.UniqueId': 'WSSAlertPlugin.L3.AlertSuppressed',
                'Event.Category': 'Alerts',
                'Event.Action': 'L3 Alert was suppressed',
                'Hit.Interactive': true,
                'Hit.User.Initiated': true
            }
        },
        'AntiSpam.Mails.ScannedInDay': {
            'map': {
                'Count': 'Event.Value'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.Mails.ScannedInDay',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Mails Scanned',
                'Event.Label': 'Mails Scanned',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        },
        'AntiSpam.Mails.SpamCntInDay': {
            'map': {
                'Count': 'Event.Value'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.Mails.SpamCntInDay',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Spam Mails',
                'Event.Label': 'Filtered Spam Mails',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        },
        'AntiSpam.Mails.AllowedBy2Big': {
            'map': {
                'Count': 'Event.Value'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.Mails.AllowedBy2Big',
                'Event.Category': 'Anti-Spam',
                'Event.Action': '2Big',
                'Event.Label': 'Allowed Mails Too Big',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        },
        'AntiSpam.Mails.AllowedByFriend': {
            'map': {
                'Count': 'Event.Value'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.Mails.AllowedByFriend',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Friend',
                'Event.Label': 'Allowed Mails Friend',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        },
        'AntiSpam.Mails.BlockedByCustomFilter': {
            'map': {
                'Count': 'Event.Value'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.Mails.BlockedByCustomFilter',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'CustomFilter',
                'Event.Label': 'Blocked Mails on Custom Filter',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        }
        ,
        'AntiSpam.Mails.BlockedByHydraScore': {
            'map': {
                'Count': 'Event.Value'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.Mails.BlockedByHydraScore',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'HydraScore',
                'Event.Label': 'Blocked Mails on Hydra Score',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        },
        'AntiSpam.Mails.BlockedByNotAFriend': {
            'map': {
                'Count': 'Event.Value'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.Mails.BlockedByNotAFriend',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'NotAFriend',
                'Event.Label': 'Blocked Mails on NotAFriend',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        },
        'Core.AntiSpam.Settings': {
            'map': {
                'state': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'Core.AntiSpam.Settings',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Changed AntiSpam setting state',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        },
        'Core.AntiSpam.ProtectionLevel': {
            'map': {
                'level': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'Core.AntiSpam.ProtectionLevel',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Set Spam Protection Level',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        },
        'Core.AntiSpam.ProtectionLevelChanged': {
            'map': {
                'level': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'Core.AntiSpam.ProtectionLevel',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Change Protection Level',
                'Hit.Interactive': false,
                'Hit.User.Initiated': false
            }
        },
        'Core.AntiSpam.AddFilteringRule': {
            'map': {
                'acounttype': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'Core.AntiSpam.AddFilteringRule',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Web-Mail accounts Added',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        },
        'Core.AntiSpam.FilteringRuleState': {
            'map': {
                'acounttype': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'Core.AntiSpam.FilteringRuleState',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Viewed Filtered Web Mails',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        },
        'AntiSpam.User.LastSpamMailSize': {
            'map': {
                'Size': 'Event.Value'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.User.LastSpamMailSize',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Spam Mail Size',
                'Event.Label': 'Spam Mail Size',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        },
        'AntiSpam.User.MarkAsSpam': {
            'map': {
                'Source': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.User.MarkAsSpam',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Mark As Spam',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        },
        'AntiSpam.User.MarkAsHam': {
            'map': {
                'Source': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'AntiSpam.User.MarkAsHam',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Mark As Ham',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        },
        'Core.AntiSpam.AddRule': {
            'map': {
                'field': 'Hit.Label.1',
                'action': 'Event.Label',
                'phrase': 'Hit.Label.2'
            },
            'default': {
                'Hit.UniqueId': 'Core.AntiSpam.AddRule',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Add Custom Filter rules',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        },
        'Core.AntiSpam.EmailProcessing': {
            'map': {
                'markedemail': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'Core.AntiSpam.EmailProcessing',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Leave Spam Mails in Inbox',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        },
        'Core.AntiSpam.Toolbar': {
            'map': {
                'toolbars': 'Event.Label'
            },
            'default': {
                'Hit.UniqueId': 'Core.AntiSpam.Toolbar',
                'Event.Category': 'Anti-Spam',
                'Event.Action': 'Disable Anti-Spam Tool Bar',
                'Hit.Interactive': false,
                'Hit.User.Initiated': true
            }
        }
    };
    var observationEngine =
    {
        "start" : function()
        {
            try
            {
                //subscribe to all events
                var messageBus = getMessageBus();
                for (var name in config) 
                {
                    messageBus.Subscribe(name);
                }
				logDebug('observationEngine Started');
            }
            catch(e)
            {
                logError('observationEngine.start(): ' + e.message);
            }
        },
        "handle": function(eventName, eventIn)
        {
            // eventIn from msgbus, eventMap from us, eventOut to analytics
            try
            {
                // get event and check if exists in events
                logDebug('observationEngine.handle() Received '+ eventName + ' : ' + JSON.stringify(eventIn));
                var eventConfig = config[eventName];
                if (!eventConfig)
                {
                    logError('observationEngine.handle() Received an invalid event: ' + eventName);
                    return;
                }

                var eventMap = eventConfig['map'];
                var eventDefault = eventConfig['default'];

                // prepare the event to send to transport
                var eventOut = {
                    'UniqueIdentifier': eventDefault['Hit.UniqueId'],
                    'type': 'event',
                    'payload': {
                        'Tracker.Type': 'event'
                    }
                };

                // do the mapping
                for (var key in eventMap)
                {
                    if (!(key in eventIn))
                    {
                        logError('observationEngine.handle() Dropping event ' + eventName + ' expecting key: ' + key);
                        return;
                    }
                    eventOut.payload[eventMap[key]] = eventIn[key];
                }

                // merge the eventOut with the default
                for (var key in eventDefault)
                {
                    if (!(key in eventOut.payload))
                    {
                        eventOut.payload[key] = eventDefault[key];
                    }
                }

                // send the JSON out
                logDebug('observationEngine.handle() Sending to transport: ' + JSON.stringify(eventOut));
                var event_handler = ModuleManager.getSingleton("event_handler");
                event_handler.handleV1Record(eventOut);
            }
            catch (e)
            {
                logError('observationEngine.handle() Failed to handle message on message bus: ' + e.message);
            }
        }
    };

    return observationEngine;
}

ModuleManager.registerFactory("observation_analytics", getObservationAnalyticsEngine);
//export  {getObservationAnalyticsEngine};
//globalEngine.FactoryMap["observation_analytics"] =  getObservationAnalyticsEngine;
    
